import { MDiningPromiseClient } from 'mdining-proto';
export default new MDiningPromiseClient('https://michigan-dining-api.tendiesti.me');
